import { RM01 } from "./RM01";
import { RM03 } from "./RM03";
import { RM05 } from "./RM05";
import { RM06 } from "./RM06";
import { RM14 } from "./RM14";

export const RegionCoverageReport = {
  sections: [
    RM06, 
    RM01,
    // RM14
  ],
};
